<template>
  <!-- 检测结果图 -->
  <div class="w-full csCard bg-white rounded-2xl overflow-hidden">
    <!-- 图片占位 -->
    <tk-flex middle center class="csCard-img">
      <div style="position: absolute; width: 100%; height: 100%;top:0; left: 0;">
        <a-empty v-if="!showImage">
          <span v-if="isImageNotAvailable" slot="description">图片未达到检测要求</span>
          <span v-else slot="description">暂无图片</span>
        </a-empty>
        <img @error="errorImage" style="object-fit: cover;width:100%; height: 100%" v-else
          :src="showImage" alt="" @click="showImages" />
      </div>
    </tk-flex>
    <div style="padding: 15px">
      <div class="card-title">
        <div>{{ item.point }}</div>
        <div class="count">总计:{{ item.pass ? '-' : item.count }}</div>
      </div>
      <!-- <div v-for="(itm, index) in item.list" :key="index" class="card-item">
        <div class="item-name">{{ itm.name }}</div>
        <div class="item-num">{{ itm.num }}</div>
      </div>
      <div style="margin-top: 8px;">
        水平参数：{{ item.horizontal }}，垂直参数：{{ item.vertical }}；
      </div> -->
    </div>
    <a-modal :maskClosable="false" v-if="showImage" destroyOnClose centered :title="item.point" :visible="visible"
      :width="modelWidth" @cancel="visible = false">
      <div class="point-warp">
        <div class="point-img">
          <div class="relative imgcont overflow-hidden rounded-2xl"
            :style="{ width: '100%', paddingBottom: `${(imageSize.height / imageSize.width) * 100}%` }" ref="imageWarp">
            <div class="imageWarp" v-for="(item, index) in allImages" :style="{ zIndex: currentIndex === index ? 1 : 0 }"
              :key="item">
              <img style="object-fit: cover;" :src="item" alt="" />
              <template v-if="hasBug && showImageIndex === index && timer === null">
                <div v-for="(item, index) in testResult" :key="index" class="bug-warp" :style="{
                  width: getX(item[2]) + 'px',
                  height: getY(item[3]) + 'px',
                  left: (item[0] / imageSize.width) * 100 + '%',
                  top: (item[1] / imageSize.height) * 100 + '%'
                }"></div>
              </template>
            </div>
          </div>
        </div>
        <div class="desc">
          <div>
            <div class="font-16" style="font-weight: 600; color: #363B45; margin: 0 0 15px;">
              累计粮虫：{{ item.pass ? '照片未达到检测要求' : item.count }}
            </div>
            <div v-if="item.message" style="padding-right: 30px;font-weight: 400; padding:0 0 15px 0;color: #FF3D00;"
              class="font-14">
              {{ item.message }}
            </div>
            <div style="padding-right: 30px;font-weight: 400; padding:0 0 15px 0;" class="font-14">
              <div style="margin-bottom: 15px;">
                水平参数：{{ item.horizontal }}，垂直参数：{{
                  item.vertical
                }}；
              </div>
              <tk-flex between><span>象甲科（米象、玉米象等）</span><span>--</span></tk-flex>
              <tk-flex between><span>拟步甲科等(谷盗等)</span><span>--</span></tk-flex>
              <tk-flex between><span>飞蚁科</span><span>--</span></tk-flex>
              <tk-flex between><span>飞蛾科</span><span>--</span></tk-flex>
              <tk-flex between><span>飞蛾幼虫类</span><span>--</span></tk-flex>
              <tk-flex between><span>未识别害虫</span><span>--</span></tk-flex>
            </div>
          </div>
          <tk-flex right>
            <a-button type="primary" class="m-r-10" @click="lookImg">图片预览</a-button>
            <a-button @click="lookGif">动图预览</a-button>
          </tk-flex>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import config from '@/config'
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isImagError: false,
      errorImageSrc: '/image/image_error.png',
      visible: false,
      modelWidth: 0,
      currentIndex: this.item.showIndex || 0,
      timer: null,
      imageWidth: 0,
      imageHeight: 0
    }
  },
  computed: {
    newimages () {
      let arr = []
      let apiUrl = this.$tkParse.options.baseURL
      if (this.item.images) {
        this.item.images.forEach((item) => {
          // 将字符串里的https://c.cechong.mokekeji.com/static/ 替换成apiurl加上/static/
          item = item.replace(
            'http://master/static/',
            apiUrl + '/static/'
          )
          arr.push(item)
        })
      }
      return arr
    },
    hasBug () {
      return (this.item.count || 0) > 0
    },
    imageSize () {
      if (this.item.data && this.item.data.size) {
        return {
          width: this.item.data.size[1],
          height: this.item.data.size[0]
        }
      } else {
        return {
          width: 1920,
          height: 1080
        }
      }
    },
    showImageIndex () {
      return this.item.showIndex || 0
    },
    isImageNotAvailable () {
      return this.item.pass
    },
    showImage () {
      if (this.item.images) {
        // if (this.item.pass) {
        //   return undefined
        // } else {
        //   return this.newimages[this.showImageIndex]
        // }
        return this.newimages[this.showImageIndex]
      } else {
        return undefined
      }
    },
    allImages () {
      return this.item.images ? this.newimages : []
    },
    testResult () {
      return this.item.data ? this.item.data.points : []
    }
  },
  watch: {
    visible (newV) {
      if (!newV) {
        if (this.timer) {
          this.lookImg()
        }
      } else {
        this.$nextTick(this.initImageRange)
      }
    }
  },
  methods: {
    errorImage () {
      this.isImagError = true
    },
    getX (x) {
      return this.imageWidth * (x / this.imageSize.width)
    },
    getY (y) {
      return this.imageHeight * (y / this.imageSize.height)
    },
    initImageRange () {
      const width = this.$refs.imageWarp.offsetWidth
      const height = this.$refs.imageWarp.offsetHeight
      this.imageWidth = width
      this.imageHeight = height
    },
    openDetails () {
      if (this.showImage && !this.isImagError) {
        this.visible = true
      }
    },
    showImages () {
      if (this.isImagError) return
      this.visible = true
    },
    lookImg () {
      clearInterval(this.timer)
      this.currentIndex = this.showImageIndex
      this.timer = null
    },
    lookGif () {
      if (this.timer) return
      this.timer = setInterval(() => {
        this.currentIndex++
        if (this.currentIndex === this.allImages.length) this.currentIndex = 0
      }, 250)
    }
  },
  mounted () {
    this.modelWidth = window.outerWidth * 0.8
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal-footer {
  display: none;
}

.point-warp {
  display: flex;
  align-items: stretch;

  .point-img {
    flex-grow: 1;
    margin-right: 20px;
  }
}

.desc {
  flex-shrink: 0;
  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.csCard {
  border: 1px solid #dde0e5;
  overflow: hidden;

  .csCard-img {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.64%;
    background: #fff;
    border-bottom: 1px solid #eee;
  }

  .card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;

    .count {
      color: #2fbf79;
      font-weight: unset;
    }
  }

  .card-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 400;
    margin-top: 8px;

    .item-name {
      flex: 1;
    }

    .item-num {
      flex-shrink: 0;
    }
  }
}

.imgcont {
  .imageWarp {
    position: absolute;
    width: 100%;
    height: 100%;

    .img {
      width: 100%;
      height: 100%;
    }

    .bug-warp {
      position: absolute;
      transform: translate(-50%, -50%);
      border: 2px solid #ff3d00;
    }
  }
}
</style>
